/* index.js */

"use strict";

const uiCore = require("@gluenetworks/steve_ui_core");
const ButtonControl = uiCore.Control.Action.Button;

module.exports = {
    checkboxFormatter,
    cellWithTitle,
    actionButtonsFormatter,
    valueMapFormatter,
    usageColumnFormatter,
};

function cellWithTitle(row, cell, value /*, columnDef, dataContext*/) {
    const span = document.createElement("span");
    span.setAttribute("title", value);
    span.innerText = value || "";
    return span.outerHTML;
}

function checkboxFormatter(row, cell, value /*, columnDef, dataContext*/) {
    let checkbox = document.createElement("div");
    if (value) {
        checkbox = document.createElement("base-icon-gl");
        checkbox.dataset.icon = "common.check";
        checkbox.setDarkTheme(true);
    }
    return checkbox.outerHTML;
}

function actionButtonsFormatter(/*oSManagementComponent*/) {
    return (row, cell, identifier, columnDef /* , dataContext*/) => {
        const actions = [
            _generateButtons("Edit", "edit", row),
            _generateButtons("Delete", "delete", row),
        ];

        if (identifier === "MAIN") {
            actions.push(_generateButtons("Refresh", "refresh", row));
            /*
            //leave 'SSH Keys' for the future
            let _showKeysButton;
            const sshBtnIsDisabled = !oSManagementComponent.canGenerateKeys(dataContext.id);
            _showKeysButton = _generateButtons("SSH keys", "getKeys", row, sshBtnIsDisabled);
            return `${_editButton.renderer.rootElement.outerHTML}`;
            */
        }

        columnDef.width = Math.max(columnDef.width, actions.length * 60 + 10);
        return actions.map((btn) => btn.renderer.rootElement.outerHTML).join("");
    };
}

function valueMapFormatter(mapObject = {}) {
    return function mappedFormatter(row, cell, value) {
        return mapObject.hasOwnProperty(value) ? mapObject[value] : value;
    };
}

function usageColumnFormatter(row, cell, value /*, columnDef, dataContext*/) {
    let container = document.createElement("div");
    if (value) {
        container.innerText = value + "%";
    } else {
        container.innerText = "-";
    }
    return container.outerHTML;
}

function _generateButtons(label, action, row, disabled) {
    const btn = new ButtonControl({
        label: label,
        darkTheme: true,
        disabled: disabled,
    });
    btn.setAttribute("role", "button");
    btn.setAttribute("action", action);
    btn.setAttribute("row", row);
    return btn;
}
